import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=e4332cc8"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=e4332cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports